import { useEffect, useState } from 'react';
import '../css/tutorial.css';
import support from '../assets/support.png';

export const Tutorial = ({ initialId = 0, finalId }) => {
    const [stepId, setStepId] = useState(initialId);
    const [isShow, setIsShow] = useState(false);
    const texts = [
        '👋 Bienvenido a la app de la Unión Industrial de Tres de Febrero. En pocos pasos vas a aprender a participar en eventos y rondas de negocios.',
        'Iniciá sesión si tenés una cuenta o registrate si no tenés una.',
        'Completá todos los campos y presioná "Siguiente".',
        'Seleccioná los rubros a los que pertenece tu empresa, ingresá los productos que fabrique tu empresa y los productos que necesite tu empresa. Cuanto más completo esté mejor, esto ayudará a tener mejores reuniones en la ronda.',
        'Ingresá el o los representantes que usará tu empresa en los distintos eventos. Por último hacé clic en "Registrarse". ',
        'Acá vas a encontrar todos los eventos disponibles. Si querés participar, hacé clic en “Inscribirse”.',
        'Una vez inscripto en una Ronda de Negocios, vas a ver las empresas participantes. Desde acá podés conocer sus perfiles y solicitar reuniones.',
        'Cada empresa tendrá un botón de "Reunirse". Este botón te permite enviar una solicitud de reunión a otra empresa.',
        'Acá podés ver todos los eventos en los que estás inscripto y las empresas con las que te quisiste reunir.',
        'Desde acá podés ver y editar tu perfil, cambiar la contraseña o cerrar sesión.',
        '¡Listo! Ya sabés cómo usar la app de la UI3F. Participá, generá contactos y aprovechá al máximo las oportunidades de la Unión Industrial.'
    ]
    const titles = [
        'Bienvenido',
        'Inicio',
        'Registro',
        'Registro',
        'Registro',
        'Eventos',
        'Lista de empresas',
        'Lista de empresas - Reunirse',
        'Mis actividades',
        'Perfil de usuario',
        'Final del tutorial'
    ]
    const helpers = [
        '',
        'Una vez, completado este paso, te seguiremos dando indicaciones.',
        'Una vez, completado este paso, te seguiremos dando indicaciones.',
        'Una vez, completado este paso, te seguiremos dando indicaciones.',
        'Una vez registrado, evaluaremos tu registro y te comunicaremos por mail una vez esté aprobado.',
        '',
        'Usá el buscador o filtros para encontrar empresas por rubro, productos buscados, productos ofrecidos o nombre.',
        'Si ambos aceptan, el sistema agenda la reunión automáticamente.',
        'También podés darte de baja si no vas a asistir o cancelar la invitación.',
        'Te recomendamos mantener tu información actualizada para mejorar las reuniones en las rondas.',
        ''
    ]

    useEffect(() => {
        setStepId(initialId)
    }, [initialId])
    useEffect(() => {
        document.querySelectorAll('.resaltarTutorial').forEach(el => {
            el.classList.remove('resaltarTutorial');
        });
        document.querySelectorAll('.opacity-10').forEach(el => {
            el.classList.remove('opacity-10');
        });
        if (initialId >= 5) {
            document.getElementById('navbarNavDropdown').classList.add('z-10')
            document.getElementById('navbarMobile').classList.remove('z-1500')
            if (isShow) {
                document.querySelectorAll('.nav-link').forEach(el => {
                    el.classList.add('opacity-10');
                });
                if (stepId < texts.length - 1) {
                    const tabId =
                        stepId == 9
                            ? 'empresaNav'
                            : `tab-${[6, 7].includes(stepId) ? 'empresas' : stepId == 5 ? 'eventos' : 'actividades'}`;
                    const tabIdMov =
                        stepId == 9
                            ? 'empresaNav'
                            : `tab-mov-${[6, 7].includes(stepId) ? 'empresas' : stepId == 5 ? 'eventos' : 'actividades'}`;
                    const tabIdCel =
                        stepId == 9
                            ? 'tab-cel-profile'
                            : `tab-cel-${[6, 7].includes(stepId) ? 'empresas' : stepId == 5 ? 'eventos' : 'actividades'}`;


                    document.getElementById(tabId).classList.add('resaltarTutorial')
                    document.getElementById(tabIdMov).classList.add('resaltarTutorial')
                    document.getElementById(tabIdCel).classList.add('resaltarTutorial')
                    document.getElementById(tabIdCel).classList.remove('opacity-10')
                    document.getElementById('navbarNavDropdown').classList.remove('z-10')
                    document.getElementById('navbarMobile').classList.add('z-1500')
                }
            }
        }
    }, [stepId, isShow])


    const next = () => {
        if (stepId == texts.length - 1 || stepId == finalId) {
            document.getElementById('closeTut').click()
            //setStepId(initialId)
        }
        else
            setStepId(stepId + 1)
    }
    const back = () => {
        setStepId(stepId - 1)
    }

    return (
        <>
            <div class="modal fade " id="tutorialModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
                aria-labelledby="tutorialModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered ">
                    <div class="modal-content rounded-4 modal-tutorial">

                        <div class="modal-body px-0 py-5">
                            <button type="button" id='closeTut' class="btn-close btn-close-modal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setIsShow(false)}></button>
                            <div className='container px-5 '>
                                <h3 className='mb-4'>{titles[stepId]}</h3>
                                {texts[stepId]}
                                {helpers[stepId] !== '' && <p className='helperTut'>{helpers[stepId]} </p>}
                                <div className='py-2'>
                                    {stepId > initialId &&
                                        <button class="btn btn-outline-primary bold-botones me-3 mt-4 " type="submit" onClick={back}>
                                            Anterior
                                        </button>}
                                    <button class="btn colorPrincipal text-white bold-botones mt-4" type="submit" onClick={next}>
                                        {stepId == 0 ? 'Empezar' : stepId == texts.length - 1 || stepId == finalId ? 'Entendido' : 'Siguiente'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`container contTut  mt-sm-4 mt-2 ${initialId == 0 ? 'contTutCentrado' : initialId > 1 && initialId < 5 ? 'containerRegistro' : 'container-width-85'}`}>
                <button id="verTutorial" className={`btn-tutorial  ${initialId == 0 ? 'mx-auto' : 'ms-auto'}`}
                    data-bs-toggle="modal" data-bs-target="#tutorialModal" onClick={() => setIsShow(true)} >
                    <img src={support} alt="" />
                    <div className='d-none d-sm-block'>¿Cómo usar la aplicación?</div>
                    <div className='d-block d-sm-none'>Ayuda</div>
                </button>
            </div>
        </>
    );
};